module.exports = __webpack_public_path__ + "img/355.fcb78eef.png";